<template>
  <div class="card border-0 shadow-sm rounded-4 app-card">
    <div class="card-body p-4">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.app-card {
  background: #ffffff;
}
</style>
